<template>
  <sui-message class="notification" :class="[notification.type]" size="mini" dismissable @click="onClick($event)">
    <div class="image" :is="link ? 'router-link' : 'div'" :to="link">
      <Logo class="ui image logo" :entity="entity" :email="entity.email" data-goal="NOTIFICATIONS_OPEN_ENTITY" v-if="image" />
      <i class="icon" :class="icon" data-goal="NOTIFICATIONS_OPEN_ENTITY" v-if="!image" />
    </div>
    <sui-message-content>
      <div class="header" v-if="header">
        {{header}}
      </div>
      <p v-if="notification.text">
        {{notification.text}}
      </p>
      <sui-button-group class="fluid" size="mini" v-if="notification.buttons">
        <sui-button :class="button.class" v-for="button in notification.buttons" :key="button.text" @click="button.action ? button.action() : close()">
          {{button.text}}
        </sui-button>
      </sui-button-group>
    </sui-message-content>
    <div class="progress" :style="progressStyle" />
  </sui-message>
</template>

<script>
  import capitalize from 'lodash/capitalize'
  import store from '@/store'
  import utils from '@/utils'

  export default {
    name: 'Notification',
    props: {
      notification: {
        type: Object,
        required: true,
      },
      focused: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data() {
      const delay = typeof this.notification.delay === 'undefined' ? store.getters.config.notificationsDelay : this.notification.delay
      return {
        started: 0,
        translateX: 0,
        transitionDuration: delay,
        delay: delay,
      }
    },
    computed: {
      autoClosing() {
        return this.focused && this.delay !== 0 && !this.notification.buttons
      },
      entity() {
        return this.notification.entity || null
      },
      header() {
        if (this.notification.header) {
          return this.notification.header
        }
        if (this.entity) {
          const target = capitalize(this.entity.target)
          const name = this.entity.name ? ` "${this.entity.name}"` : ''
          return `${target}${name}`
        }
        return null
      },
      image() {
        return this.notification.image || (this.entity ? this.entity._logo || this.entity.email : null)
      },
      icon() {
        return this.notification.icon || (this.entity ? this.entity.icon : 'info circle')
      },
      link() {
        return this.notification.link || (this.entity ? this.entity._path : null)
      },
      progressStyle() {
        return {
          transform: `translate(${this.translateX}%, 0)`,
          transitionDuration: `${this.transitionDuration}ms`,
        }
      },
    },
    watch: {
      autoClosing: {
        immediate: true,
        handler(newValue) {
          const now = Date.now()
          if (newValue) {
            this.transitionDuration = this.delay * (100 - this.translateX) / 100
            this.$options.timeout = setTimeout(this.close, this.transitionDuration)
            this.started = now
            this.$nextTick(() => { this.translateX = 100 })
          } else {
            this.translateX = 100 * (this.delay - this.transitionDuration + (now - (this.started || now))) / this.delay
            this.transitionDuration = 0
            clearTimeout(this.$options.timeout)
          }
        },
      }
    },
    methods: {
      close() {
        this.$emit('dismiss')
      },
      onClick(event) {
        if (event.target.className === 'close icon') {
          utils.reachGoal('NOTIFICATIONS_CLOSE_ICON')
          this.close()
        } else {
          if (this.notification.action) {
            this.notification.action()
          } else {
            utils.reachGoal('NOTIFICATIONS_CLOSE')
            this.close()
          }
        }
      }
    },
    beforeDestroy() {
      if (this.$options.timeout) {
        clearTimeout(this.$options.timeout)
      }
    },
  }
</script>

<style scoped>
  .notification { position: relative; display: flex!important; align-items: flex-start; flex-wrap: nowrap; width: 300px!important; overflow: hidden; }
  .image { margin-left: -.7em; margin-right: .7em; width: 4em; display: flex; align-items: center; justify-content: center; opacity: .8; }
  .logo { margin: 0; width: 100%; border-radius: .3em; opacity: 1!important; }
  .icon { margin: 0; font-size: 2.5em; }
  .progress { position: absolute; bottom: 0; left: -100%; width: 100%; height: 3px; background-color: rgba(0,0,0,.1); transform: translate(0, 0); transition: transform 0s linear; }
</style>
